import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import axiosInstance from "../../utils/AxiosConfig";
import BlogCard from "./BlogCard";
import { useInitialData } from "../../SSR/InitialDataContext";
import "../../Styles/Blogs.css";

function BlogSection() {
  const initialData = useInitialData();
  const initialBlogs = Array.isArray(initialData?.homeBlogs)
    ? initialData.homeBlogs
    : [];
  const [blogs, setBlogs] = useState(initialBlogs);

  useEffect(() => {
    if (initialBlogs.length > 0) {
      return undefined;
    }

    let isMounted = true;

    const fetchBlogs = async () => {
      try {
        const response = await axiosInstance.get("/blogs", {
          params: {
            limit: 12,
          },
        });

        if (!isMounted) {
          return;
        }

        setBlogs(Array.isArray(response.data?.data) ? response.data.data : []);
      } catch (error) {
        if (isMounted) {
          setBlogs([]);
        }
      }
    };

    fetchBlogs();

    return () => {
      isMounted = false;
    };
  }, [initialBlogs.length]);

  if (!blogs.length) {
    return null;
  }

  const desktopSlides = Math.min(blogs.length, 3);
  const tabletSlides = Math.min(blogs.length, 2);
  const shouldLoop = blogs.length > 3;

  return (
    <section
      className="blogs-home-section"
      aria-label="Latest Health and Wellness Blogs"
    >
      <div className="blogs-home-section__inner">
        <div className="blogs-section-heading">
          <div>
            {/* <p className="blogs-section-heading__eyebrow">Elumia Insights</p> */}
            <h2>Latest Health &amp; Wellness Blogs</h2>
            <p>
              Helpful tips, product guides, and wellness insights from Elumia
              Med Store.
            </p>
          </div>
          <Link className="blogs-section-heading__cta" to="/blogs">
            View All Blogs
          </Link>
        </div>

        <div className="blogs-carousel-section">
          <div className="blogs-carousel">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              speed={800}
              loop={shouldLoop}
              pagination={{
                clickable: true,
                dynamicBullets: false,
              }}
              autoplay={
                shouldLoop
                  ? {
                      delay: 2500,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }
                  : false
              }
              watchOverflow
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: tabletSlides,
                },
                1024: {
                  slidesPerView: desktopSlides,
                },
              }}
            >
              {blogs.map((blog, index) => (
                <SwiperSlide key={`${blog.id || blog.slug}-${index}`}>
                  <div className="blogs-slide">
                    <BlogCard blog={blog} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogSection;
